import { graphql } from "react-relay";

// gql
import "./TeamSearchInput.gql";

export const fragments = {
  org: graphql`
    fragment TeamSearchInputRenderer_org on Org {
      id
    }
  `,
};

export const query = graphql`
  query TeamSearchInputRendererQuery($orgRelayId: ID!, $query: String!) {
    viewer {
      ...TeamSearchInput_viewer @arguments(orgRelayId: $orgRelayId, query: $query)
      user {
        orgs(first: 1000000) {
          edges {
            node {
              ...TeamSearchInput_org
            }
          }
        }
      }
    }
  }
`;
